import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-lg-row flex-column-fluid" }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row-fluid flex-fill col-12 col-md-6 col-lg-4 p-10" }
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-lg-row-fluid" }
const _hoisted_4 = { class: "<?php echo $params['wrapperClass']?> p-0 p-md-10" }
const _hoisted_5 = { class: "d-flex justify-content-between px-md-10 py-4" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"me-10 d-flex gap-5 d-none\"><a href=\"https://www.facebook.com/perufedup/\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-facebook-f\"></i></a><a href=\"https://twitter.com/perufedup\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-twitter\"></i></a><a href=\"https://www.instagram.com/perufedup/\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-instagram\"></i></a><a href=\"https://pe.linkedin.com/company/perufedup\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-linkedin-in\"></i></a></div>", 1)
const _hoisted_7 = { class: "d-flex flex-center flex-wrap" }
const _hoisted_8 = { class: "d-flex fw-semibold text-primary fs-base gap-2 d-block d-lg-none" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "text-muted ms-1" }
const _hoisted_11 = { class: "d-flex flex-lg-row-fluid flex-fill d-none d-md-block col-md-6 col-lg-8 bgi-size-cover bgi-position-center bg-gradient-overlay" }
const _hoisted_12 = {
  id: "carouselExampleCaptions",
  class: "carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_13 = { class: "carousel-indicators" }
const _hoisted_14 = ["data-bs-slide-to", "aria-label"]
const _hoisted_15 = { class: "carousel-inner" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "carousel-caption d-none d-md-block z-index-2" }
const _hoisted_18 = {
  key: 0,
  class: "text-white"
}
const _hoisted_19 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselExampleCaptions\" data-bs-slide=\"prev\"><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselExampleCaptions\" data-bs-slide=\"next\"><span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Next</span></button>", 2)
const _hoisted_22 = {
  class: "micontent d-flex flex-row position-absolute w-100 z-index-2 align-items-center justify-content-between px-4",
  style: {"background-color":"#050828"}
}
const _hoisted_23 = { class: "d-flex fw-semibold text-primary fs-base gap-2 align-items-center" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "m-0 text-muted" }, "Sistema de Gestión Deportiva"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/logos/hayllis.png",
    class: "h-50px",
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              href: _ctx.terms,
              target: "_blank"
            }, "Terms", 8, _hoisted_9),
            _createElementVNode("span", _hoisted_10, "©" + _toDisplayString(_ctx.appName) + " - versión " + _toDisplayString(_ctx.version), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataCompany?.setting?.sliders, (item, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: `btn-slider-${index}`,
              type: "button",
              "data-bs-target": "#carouselExampleCaptions",
              "data-bs-slide-to": index,
              class: _normalizeClass(`${index == 0 ? 'active' : ''}`),
              "aria-current": "true",
              "aria-label": `Slide ${index}`
            }, null, 10, _hoisted_14))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataCompany?.setting?.sliders, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "carousel-item active",
              key: `lst-slider-${index}`
            }, [
              _createElementVNode("img", {
                src: item?.img,
                class: "d-block w-100"
              }, null, 8, _hoisted_16),
              _createElementVNode("div", _hoisted_17, [
                (item?.title)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_18, _toDisplayString(item?.title), 1))
                  : _createCommentVNode("", true),
                (item?.subtitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(item?.subtitle), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]),
        _hoisted_20
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("a", {
            href: _ctx.terms,
            target: "_blank"
          }, "Terms", 8, _hoisted_24),
          _createElementVNode("span", _hoisted_25, "©" + _toDisplayString(_ctx.appName) + " - versión " + _toDisplayString(_ctx.version), 1)
        ]),
        _hoisted_26
      ])
    ])
  ]))
}